import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { AccessibilityProvider } from './contexts/AccessibilityContext';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { IssuesPage } from './pages/IssuesPage';
import { AboutPage } from './pages/AboutPage';
import { SubmitPage } from './pages/SubmitPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="2mmvjmq8ow89f">
      <AccessibilityProvider data-id="element-1" data-mp="2mnnhk7prei2v">
        <BrowserRouter data-id="element-2" data-mp="31aqdi9yfoio3">
          <div className="min-h-screen flex flex-col bg-[#FAF6F0] app-container" data-id="element-3" data-mp="31b8gdpflpv4z">
            <Navbar data-id="element-4" data-mp="2wka20ve6b74d" />
            <main className="flex-1 bg-[#FAF6F0] main-content" data-id="element-5" data-mp="2wjqg73lejyl2">
              <Routes data-id="element-6" data-mp="28ufp6dtutik4">
                <Route path="/" element={<IssuesPage data-id="element-8" data-mp="28t4mkhc5agul" />} data-id="element-7" data-mp="28tw44o8wqe1v" />
                <Route path="/about" element={<AboutPage data-id="element-10" data-mp="23vkuadim43jn" />} data-id="element-9" data-mp="28sbar1ybx15l" />
                <Route path="/submit" element={<SubmitPage data-id="element-12" data-mp="23t8hsfvmildz" />} data-id="element-11" data-mp="23ujksdh8vp41" />
                <Route path="/contact" element={<ContactPage data-id="element-14" data-mp="3iiwaeb4natww" />} data-id="element-13" data-mp="3ik7ekc2063oj" />
              </Routes>
            </main>
            <Footer data-id="element-15" data-mp="3ml1397n9rmih" />
          </div>
        </BrowserRouter>
      </AccessibilityProvider>
    </LanguageProvider>;
}